"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputRadioNumber = void 0;
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const surveyHelper = __importStar(require("evolution-common/lib/utils/helpers"));
const react_i18next_1 = require("react-i18next");
const InputRadio_1 = require("./InputRadio");
const InputRadioNumber = ({ id, onValueChange, value, widgetConfig, interview, path, user, t }) => {
    var _a, _b;
    const minValue = surveyHelper.parseInteger(widgetConfig.valueRange.min, interview, path, user) || 0;
    const maxValue = surveyHelper.parseInteger(widgetConfig.valueRange.max, interview, path, user) || minValue + 1;
    const [currentValue, setCurrentValue] = (0, react_1.useState)(!(0, LodashExtensions_1._isBlank)(value) ? Number(value) : -1);
    const [isOverMax, setIsOverMax] = (0, react_1.useState)(Number(value) > maxValue);
    const customInputRadioRef = react_1.default.createRef();
    const handleOnChange = (event) => {
        // "blur" is the event triggered when the input loses focus.
        // When this happens, if the text field contains "" (an empty string), then the text box is left empty
        // and it's not clear what is the true value recorded by the widget. Therefore, if the event is 'blur',
        // we change the value of the widget to `undefined` to make it appear unanswered.
        if (event.type !== 'blur' && event.target.value === '') {
            return;
        }
        const newCurrentValue = event.target.value === '' ? undefined : Number(event.target.value);
        setCurrentValue(newCurrentValue === undefined ? -1 : newCurrentValue);
        // FIXME onValueChange in the Question should not have to receive the
        // event itself or its structure. InputDatePicker already does not send
        // the target.value.  We should type and document it. Here we are
        // recreating the part of interest of the event so that unit test can
        // pass (because events are being re-used and validating its content
        // later does not work as it has been changed).
        onValueChange({ target: { value: newCurrentValue } });
        if (newCurrentValue !== undefined && newCurrentValue > maxValue) {
            setIsOverMax(true);
        }
        else {
            setIsOverMax(false);
        }
    };
    // TODO: The three functions below are copied from InputRadio.tsx.
    // Ideally we would not repeat code like this.
    const onRadioClick = (e) => {
        e.stopPropagation();
    };
    const onLabelClick = (e) => {
        e.stopPropagation();
    };
    const onContainerClick = (inputRadioRef, value, e) => {
        var _a;
        e.stopPropagation();
        const clickEvent = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: false
        });
        if (inputRadioRef.current) {
            inputRadioRef.current.dispatchEvent(clickEvent);
        }
        else {
            // it means the clicked container is the custom one:
            (_a = customInputRadioRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(clickEvent);
        }
    };
    const choiceList = [];
    for (let i = minValue; i <= maxValue; i += 1) {
        const choice = {
            value: i,
            label: i.toString(),
            icon: widgetConfig.icon,
            inputIconPath: widgetConfig.inputIconPath
        };
        choiceList.push(react_1.default.createElement(InputRadio_1.InputRadioChoiceT, { checked: currentValue === i, key: `${id}_${i}`, id: `${id}_${i}`, choice: choice, iconSize: ((_a = widgetConfig.inputIconPath) === null || _a === void 0 ? void 0 : _a.iconSize) || '2em', path: path, user: user, interview: interview, onRadioInputChange: handleOnChange, onRadioClick: onRadioClick, onContainerClick: onContainerClick, onLabelClick: onLabelClick }));
    }
    const overMaxChoice = {
        value: maxValue + 1,
        label: `${maxValue + 1}+`,
        icon: widgetConfig.icon,
        inputIconPath: widgetConfig.inputIconPath
    };
    return (react_1.default.createElement("div", { className: `survey-question__input-radio-group-container${widgetConfig.sameLine === false ? ' no-wrap' : ''}` },
        choiceList,
        widgetConfig.overMaxAllowed && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(InputRadio_1.InputRadioChoiceT, { checked: Number(value) > maxValue, key: `${id}_${maxValue + 1}`, id: `${id}_${maxValue + 1}`, choice: overMaxChoice, iconSize: ((_b = widgetConfig.inputIconPath) === null || _b === void 0 ? void 0 : _b.iconSize) || '2em', path: path, user: user, interview: interview, onRadioInputChange: handleOnChange, onRadioClick: onRadioClick, onContainerClick: onContainerClick, onLabelClick: onLabelClick }),
            isOverMax && (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: '1rem' } },
                react_1.default.createElement("label", { htmlFor: `${id}over-max` },
                    react_1.default.createElement("span", null, t(['survey:SpecifyAboveLimit', 'main:SpecifyAboveLimit']) + ':')),
                react_1.default.createElement("input", { type: "number", pattern: "[0-9]*", className: `apptr__form-input apptr__input-string input-${widgetConfig.iconSize || 'large'}`, style: { width: '6rem' }, name: `${id}over-max`, id: `${id}over-max`, defaultValue: currentValue, min: maxValue + 1, onBlur: handleOnChange, onMouseUp: handleOnChange })))))));
};
exports.InputRadioNumber = InputRadioNumber;
exports.default = (0, react_i18next_1.withTranslation)()(exports.InputRadioNumber);
//# sourceMappingURL=InputRadioNumber.js.map